import { useSubscriptionStatus } from "@/components/settings/account-plan-state";

export interface WallMemoryTool {
  /**
   * The plan includes the knowledge graph: the wall shows its tile and new
   * memory cards, and ensures its frame. While the plan loads, none of them.
   */
  available: boolean;
  /** The plan has loaded or failed to: `available` is final. */
  known: boolean;
}

/** Memory is the knowledge graph's, a Pro tool. */
export function useMemoryTool(): WallMemoryTool {
  const { status, failed } = useSubscriptionStatus();
  return {
    available: status?.has_pro_access === true,
    known: status !== null || failed,
  };
}
